import React from 'react';
const days = ['Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

export const ScheduleTable = ({ schedule, allCustomDriverShifts }) => {
   const { rows, weeks } = schedule;

   return (
      <table className="schedule-management__schedule-table">
         <thead>
            <tr>
               <th className="schedule-management__position-header" rowSpan="2">
                  Position
               </th>
               <th className="schedule-management__driver-header" rowSpan="2">
                  Driver
               </th>
               {weeks.map((week, i) => (
                  <th className="schedule-management__week-header" key={i} colSpan={7}>
                     Week {week.week_type + 1}
                  </th>
               ))}
            </tr>
            <tr>
               {weeks.map((_, weekIndex) =>
                  days.map((day, dayIndex) => (
                     <th className="schedule-management__day-header" key={`${weekIndex}-${dayIndex}`}>
                        {day}
                     </th>
                  ))
               )}
            </tr>
         </thead>
         <tbody>
            {rows.map((row) => {
               const rotation = row.driver && row.driver.rotation_position % weeks.length;
               const rotatedWeeks = [...weeks.slice(-rotation), ...weeks.slice(0, -rotation)];

               // Look for custom shifts for this driver
               let driverCustomShifts = undefined;
               if (row.driver)
                  driverCustomShifts = allCustomDriverShifts.find((d) => d.employee_id === row.driver.employee_id);

               return (
                  <tr key={row.id}>
                     <td>{row.driver ? row.driver.rotation_position + 1 : '---'}</td>
                     <td className="schedule-management__driver-cell">
                        {row.driver ? (
                           <div className="schedule-management__driver-assigned">
                              <span className="schedule-management__mini-avatar">
                                 {row.driver.name
                                    .split(' ')
                                    .map((n) => n[0])
                                    .join('')
                                    .slice(0, 2)
                                    .toUpperCase()}
                              </span>
                              <span className="schedule-management__driver-assigned-name">{row.driver.name}</span>
                              <span>({row.driver.id})</span>
                           </div>
                        ) : (
                           <span className="schedule-management__empty-driver">Unassigned</span>
                        )}
                     </td>
                     {rotatedWeeks.map((week, weekIndex) => (
                        <ScheduleWeekRow
                           key={weekIndex}
                           week={week}
                           weekIndex={weekIndex}
                           driverCustomShifts={driverCustomShifts}
                        />
                     ))}
                  </tr>
               );
            })}
         </tbody>
      </table>
   );
};

const ScheduleWeekRow = ({ week, weekIndex, driverCustomShifts }) => {
   const driverCustomWeeks = driverCustomShifts ? driverCustomShifts.weeks : [];

   return days.map((_, dayIndex) => {
      const dayOfWeek = dayIndex;

      let shift = null;

      // Look in the regular schedule
      const calendarDay = week.days.find((d) => d.dayofweek === dayOfWeek);
      if (calendarDay && calendarDay.shifts.length > 0) {
         shift = calendarDay.shifts[0];
      }

      // If no custom shift found, look for a custom shift for this driver on this day
      if (!shift && driverCustomWeeks.length > 0) {
         const customWeek = driverCustomWeeks.find((w) => w.week_type === week.week_type);
         if (customWeek) {
            const customDay = customWeek.days.find((d) => d.dayofweek === dayOfWeek);
            if (customDay && customDay.shifts.length > 0) {
               shift = customDay.shifts[0]; // Solo el primero si hay varios
            }
         }
      }

      // Render off day if no shift
      if (!shift) {
         return <td key={`${weekIndex}-${dayIndex}`} className="schedule-management__off-cell"></td>;
      }

      return (
         <td
            key={`${weekIndex}-${dayIndex}`}
            className={`schedule-management__work-cell`}
            style={{ backgroundColor: shift.color === '#ffffff' ? '#FF9AB2' : shift.color }}
         >
            <div>
               <span>{shift.name}</span>
            </div>
         </td>
      );
   });
};
